import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {FormattedDate} from '@pb/kit-component-formatters';

import {
    userConferencesLicenseDataSelector,
    userConferencesLicenseResultSelector,
} from '../../slices/user-conferences-license.slice';

type Props = {
    accountId: number,
};

export const LicenseEndDateCell = ({accountId}: Props) => {
    const {isLoading, loadingError} = useSelector(userConferencesLicenseDataSelector);
    const result = useSelector(userConferencesLicenseResultSelector);

    const licenseEnds = useMemo(() => {
        if (!result?.data[accountId]) {
            return undefined;
        } else {
            return result?.data[accountId].licenseEnds;
        }
    }, [result, accountId]);

    if (isLoading || loadingError || !licenseEnds) {
        return null;
    }

    return (
        <span>
            {FormattedDate.format({value: licenseEnds, format: 'MMM-DD-YYYY'})}
        </span>
    );
};
